import React from "react";
import Api from "./service/Api";
import {MODE_DESKTOP, MODE_MOBILE, DEFAULT_ZOOM, DEFAULT_ZOOM_MOBILE, GOOGLE_MAPS_KEY} from "./Const";
import "./assets/style.scss";
import Desktop from "./views/Desktop";
import Mobile from "./views/Mobile";
import {LoadScript} from '@react-google-maps/api';

const initialState = {
    application: {
        url: ''
    },
    layout: {
        mode: MODE_MOBILE,
        navigationOpen: false
    },
    mapProps: {
        center: {
            lat: 50.8835239,
            lng: 10.2,
        },
        zoom: DEFAULT_ZOOM,
        loading: false,
        height: 'calc(100vh - 83px)'
    },
    map: null,
    categories: [],
    members: [],
    membersCount: 0,
    membersMap: [],
    detail: {
        key: null,
        member: null
    },
    filter: {
        placeholder: 'Bitte Standort eingeben.',
        lat: null,
        lng: null,
        radius: 50,
        sort: null,
        categories: []
    }
}


class App extends React.Component {

    static defaultProps = {
        libraries: ['places']
    };

    constructor(props) {
        super(props);
        this.state = initialState;
        this.autocomplete = null;
        this.googlemap = null;
        window.addEventListener('resize', this.handleResize);

    }

    componentDidMount() {
        this.setState({
            application: {
                ...this.state.application,
                url: window.location.href
            }
        });

        this.startUpApplication();
        this.handleResize();
        //this.getMembers(true);
        this.getCategories();

    }

    startUpApplication = () => {

        let startupFilter = {...this.state.filter};

        try {

            const urlParams = new URLSearchParams(window.location.search);

            const categoryId = urlParams.get('categoryId');
            const categories = urlParams.get('categories');
            const lat = urlParams.get('lat');
            const lng = urlParams.get('lng');
            const radius = urlParams.get('radius');
            const sort = urlParams.get('sort');

            if (
                categoryId !== null &&
                categoryId !== '' &&
                !this.state.filter.categories.includes(categoryId)
            ) {
                startupFilter.categories.push(categoryId);
            } else if (categories !== null && categories !== '') {
                startupFilter.categories = categories.split(',');
            }

            if (lat !== null && lat !== '') {
                startupFilter.lat = lat;
            }

            if (lng !== null && lng !== '') {
                startupFilter.lng = lng;
            }

            if (radius !== null && radius !== '') {
                startupFilter.radius = parseInt(radius);
            }


            if (sort !== null && sort !== '') {
                startupFilter.sort = sort;
            }

            this.setState({
                filter: {
                    ...this.state.filter,
                    ...startupFilter
                }
            }, () => {
                this.getMembers(true);
            })

        } catch (error) {
            console.log(error);
        }

    }

    writeParameters = (filters) => {

        const urlParams = new URL(window.location);
        filters.forEach(filter => {
            let cond = filter.split('=');
            urlParams.searchParams.set(cond[0], cond[1]);
        })

        window.history.pushState({}, '', urlParams);

    }

    onUnmount = () => {
        this.setState({
            map: null
        })
    }



    handleResize = (resize) => {
        let mode = MODE_DESKTOP;
        if (window.innerWidth < 1024) {
            mode = MODE_MOBILE;
        }

        this.setState({
            mapProps: {
                ...this.state.mapProps,
                zoom: DEFAULT_ZOOM_MOBILE
            },
            layout: {
                ...this.state.layout,
                mode
            }
        })
    }

    handleMobileFilter = (event) => {
        event.preventDefault();
        this.setState({
            layout: {
                ...this.state.layout,
                navigationOpen: (!this.state.layout.navigationOpen)
            }
        })
    }

    getCategories = () => {
        Api.get('category?order=category_title&category_type=specialization').then(result => {
            this.setState({
                categories: result.data.items
            })
        })
    }

    getMembers = (firstLoad = false) => {

        if (this.state.loading === true) {
            return;
        }

        let filters = [];

        filters.push('member_post_status=publish')

        if (this.state.filter.lat !== null) {
            filters.push('lat=' + this.state.filter.lat);
        }

        if (this.state.filter.lng !== null) {
            filters.push('lng=' + this.state.filter.lng);
        }

        if (this.state.filter.radius !== null) {
            filters.push('radius=' + this.state.filter.radius);
        }

        if (this.state.filter.categories.length > 0) {
            filters.push('categories=' + this.state.filter.categories.join(','));
        }

        if (this.state.filter.sort !== null) {
            filters.push('sort=' + this.state.filter.sort);
        }

        filters.push('reducer=true');

        Api.get('member?' + filters.join('&')).then(result => {

            this.setState({
                filter: {
                    ...this.state.filter,
                    radius: result.data.radius
                },
                mapProps: {
                    ...this.state.mapProps,
                    zoom: this.getZoomLevel(),
                    loading: false,
                    radius: result.data.radius
                },
                members: result.data.items,
                membersCount: result.data.total,
            }, () => {
                this.setState({
                    mapProps: {
                        ...this.state.mapProps,
                        zoom: this.getZoomLevel()
                    }
                }, () => {
                    this.writeParameters(filters);
                })
            })

        });


    }

    onLoadAutocomplete = (autocomplete) => {
        this.autocomplete = autocomplete
    }

    handleAutocomplete = (filter) => {

        this.setState({
            mapProps: {
                ...this.state.mapProps,
                center: {
                    lat: filter.lat,
                    lng: filter.lng,
                }
            },
            filter: {
                ...filter,
                radius: 50
            }
        }, () => {
            this.getMembers();
        })
    }

    removeAutocomplete = (event) => {
        event.preventDefault();
        this.setState({
            mapProps: initialState.mapProps,
            filter: {
                ...this.state.filter,
                lat: null,
                lng: null,
                radius: initialState.filter.radius
            }
        }, () => {
            this.getMembers();
        })
    }

    handleToggleOpenInfoWindow = (event, member, memberIndex) => {

        this.setState({
            detail: {
                key: memberIndex,
                member: member
            }
        });

    };

    handleGeoPosition = (event) => {
        event.preventDefault();

        this.setState({
            filter: {
                ...this.state.filter,
                placeholder: 'Bitte warten...'
            }
        }, () => {
        })

        navigator.geolocation.getCurrentPosition((position) => {

            this.setState({
                mapProps: {
                    ...this.state.mapProps,
                    center: {
                        lat: position.coords.latitude,
                        lng: position.coords.longitude,
                    }
                },
                filter: {
                    ...this.state.filter,
                    lat: position.coords.latitude,
                    lng: position.coords.longitude,
                    placeholder: 'Standort'
                }
            }, () => {
                this.getMembers();
            })
        });


    }

    handleCategorySelect = (event) => {

        let categories = [...this.state.filter.categories];

        if (event.target.checked === true) {
            categories.push(event.target.value);
        } else {
            const index = categories.indexOf(event.target.value);
            if (index > -1) {
                categories.splice(index, 1);
            }
        }

        this.setState({
            filter: {
                ...this.state.filter,
                categories: categories
            }
        }, () => {
            this.getMembers();
        })

    }


    search = (event) => {
        event.preventDefault();
    }

    getZoomLevel = () => {

        try {
            if (
                this.state.filter.lat === null ||
                this.state.filter.lng === null
            ) {
                if (this.state.layout.mode === MODE_MOBILE) {
                    return DEFAULT_ZOOM_MOBILE;
                }
                return DEFAULT_ZOOM;
            }
        } catch (error) {

        }

        let zoom = DEFAULT_ZOOM;

        switch (true) {
            case (this.state.filter.radius < 50):
                zoom = 12;
                break;
            case (this.state.filter.radius > 300):
                zoom = 6;
                break;
            case (this.state.filter.radius > 200):
                zoom = 7;
                break;
            case (this.state.filter.radius >= 100):
                zoom = 8;
                break;
            case (this.state.filter.radius >= 50):
                zoom = 10;
                break;
            default:
                zoom = DEFAULT_ZOOM;
                if (this.state.layout.mode === MODE_MOBILE) {
                    zoom = DEFAULT_ZOOM_MOBILE;
                }

                break;
        }

        return zoom;
    }

    handleSliderChange = (value) => {
        this.setState({
            filter: {
                ...this.state.filter,
                radius: value
            }
        })
    }

    handleSliderChangeComplete = () => {
        this.getMembers();
    }

    onChangeSort = (sort) => {
        this.setState({
            filter: {
                ...this.state.filter,
                sort: sort
            }
        }, () => {
            this.getMembers();
        })
    }

    render() {
        return (
            <div className="dg-application">
                <LoadScript googleMapsApiKey={GOOGLE_MAPS_KEY} libraries={["places, cities"]}>
                {
                    (this.state.layout.mode === MODE_DESKTOP)
                    ? <Desktop
                            application={this.state.application}
                            filter={this.state.filter}
                            categories={this.state.categories}
                            members={this.state.members}
                            mapItems={this.state.membersMap}
                            mapProps={this.state.mapProps}
                            onSelectCategory={(event) => this.handleCategorySelect(event)}
                            onSelectPlace={this.handleAutocomplete}
                            onSliderChange={this.handleSliderChange}
                            onSliderChangeComplete={this.handleSliderChangeComplete}
                            onChangeSort={this.onChangeSort}
                            handleGeoPosition={this.handleGeoPosition}
                            removeGeoPosition={this.removeAutocomplete}
                            version={'DESKTOP'}

                        />
                    : <Mobile
                            application={this.state.application}
                            filter={this.state.filter}
                            categories={this.state.categories}
                            members={this.state.members}
                            mapItems={this.state.membersMap}
                            mapProps={this.state.mapProps}
                            onSelectCategory={(event) => this.handleCategorySelect(event)}
                            onSelectPlace={this.handleAutocomplete}
                            onSliderChange={this.handleSliderChange}
                            onSliderChangeComplete={this.handleSliderChangeComplete}
                            onChangeSort={this.onChangeSort}
                            handleGeoPosition={this.handleGeoPosition}
                            removeGeoPosition={this.removeAutocomplete}
                            version={'MOBILE'}
                        />
                }
                </LoadScript>
            </div>
        )
    }

}

export default App;


